import type { DataResponse, SuccessResponse } from '@/api/types';
import { gateway } from '..';
import type { LanguageResource } from './resources/LanguageResource';
import type { ReasonResource } from './resources/ReasonResource';

export function getMyCurrency() {
    return gateway
        .get<
            DataResponse<{
                code: string;
                symbol: string;
            }>
        >('legacy-api/v1/my_currency')
        .then((response) => response.data);
}

export function fetchLanguages(orderBy = 'is_top', order = 'desc') {
    const params = {
        order_by: orderBy,
        order,
    };
    return gateway
        .get<DataResponse<LanguageResource[]>>('/legacy-api/v1/languages', { params })
        .then((response) => response.data.data);
}

export function getRateReasons(type: string) {
    return gateway
        .get<DataResponse<ReasonResource>>(`/legacy-api/v1/rate-reasons?type=${type}`)
        .then((response) => response.data);
}

export function getDeleteReasons(type: string) {
    return gateway
        .get<DataResponse<ReasonResource>>(`/legacy-api/v1/delete-reasons?type=${type}`)
        .then((response) => response.data);
}

export function getAssociatedCredits(id: number) {
    return gateway
        .get<
            DataResponse<{ total_associated_credits: number }>
        >(`/legacy-api/v1/users/credits/associated/document/${id}`)
        .then((response) => response.data);
}

export function storeSubscriptionCancelReason(reason_ids: string, comment?: string | null) {
    return gateway
        .post<DataResponse<SuccessResponse>>(`legacy-api/v1/users/premium-cancel-reason`, { reason_ids, comment })
        .then((response) => response.data);
}
